import React, { useState } from 'react';
import { Typography, Box, TextField, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Send } from '@mui/icons-material';

import { useAppDispatch, useAppSelector } from 'hooks';
import { sendUpdatePassword } from 'state/auth';

interface Props {}

const UpdatePasswordForm: React.FunctionComponent<Props> = ({}) => {
    const dispatch = useAppDispatch();

    const { tokens } = useAppSelector((root) => root.auth);

    const [oldPassword, setOldPassword] = useState<string>();
    const [newPassword, setNewPassword] = useState<string>();
    const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>();

    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const isValid =
        newPassword === newPasswordConfirm &&
        tokens.object?.accessToken != null;

    const sendUpdatePasswordRequest = async () => {
        if (!oldPassword || !newPassword || !newPasswordConfirm) return;

        setSending(true);
        setError('');
        setMessage('');

        try {
            const results = await dispatch(
                sendUpdatePassword({
                    old_password: oldPassword,
                    password: newPassword,
                    confirm_password: newPasswordConfirm,
                }),
            );

            if (results.error) setError(results.error);

            if (results.success) setMessage('Command sent successfully');
        } finally {
            setSending(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateRows: 'auto auto 1fr auto',
            }}
        >
            <Typography variant="h6">Update Password</Typography>
            {error && (
                <Alert severity="error" onClose={() => setError('')}>
                    {error}
                </Alert>
            )}
            {message && (
                <Alert severity="success" onClose={() => setMessage('')}>
                    {message}
                </Alert>
            )}

            <Typography variant="body1">
                Fill the form and click submit to update your password
            </Typography>
            {/* Section for Command Parameters */}
            <Box sx={{ display: 'grid', gap: 1 }}>
                <TextField
                    label="Current Password"
                    type="password"
                    value={oldPassword}
                    onChange={(event) => setOldPassword(event.target.value)}
                />
                <TextField
                    label="New Password"
                    type="password"
                    value={newPassword}
                    onChange={(event) => setNewPassword(event.target.value)}
                />
                <TextField
                    label="Confirm New Password"
                    type="password"
                    value={newPasswordConfirm}
                    onChange={(event) =>
                        setNewPasswordConfirm(event.target.value)
                    }
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton
                    variant="contained"
                    onClick={sendUpdatePasswordRequest}
                    loading={sending}
                    disabled={!isValid}
                    endIcon={<Send />}
                >
                    Submit
                </LoadingButton>
            </Box>
        </Box>
    );
};

UpdatePasswordForm.displayName = 'UpdatePasswordForm';
export default UpdatePasswordForm;
